module.exports = __webpack_public_path__ + "img/ic_search-1.fa02f5e3.svg";